import createReactComponent from '../createReactComponent';
export default createReactComponent('article', 'IconArticle', [
  [
    'path',
    {
      d: 'M3 4m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z',
      key: 'svg-0',
    },
  ],
  ['path', { d: 'M7 8h10', key: 'svg-1' }],
  ['path', { d: 'M7 12h10', key: 'svg-2' }],
  ['path', { d: 'M7 16h10', key: 'svg-3' }],
]);
